export const BANNER_VARIANTS = {
  PRIMARY: 'primary',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

type BannerVariants = typeof BANNER_VARIANTS;
export type BannerVariant = BannerVariants[keyof BannerVariants];
